import { resolveDeviceModelImage } from "../../Utils/deviceModelImage"
import "./DeviceModelImage.scss"

const LaptopSvg = ({ color }) => (
  <svg viewBox="0 0 96 64" fill="none" aria-hidden>
    <rect x="14" y="8" width="68" height="42" rx="4" fill={color} opacity="0.14" />
    <rect x="18" y="12" width="60" height="34" rx="2" fill={color} opacity="0.22" />
    <rect x="22" y="16" width="52" height="26" rx="1.5" fill="#0f172a" opacity="0.55" />
    <path
      d="M8 52h80c1.5 0 2.5 1.2 2 2.5-.4 1-1.4 1.5-2.5 1.5H8.5C7.4 56 6.4 55.5 6 54.5 5.5 53.2 6.5 52 8 52Z"
      fill={color}
      opacity="0.85"
    />
    <rect x="40" y="53.5" width="16" height="1.5" rx="0.75" fill="#fff" opacity="0.55" />
  </svg>
)

const DesktopSvg = ({ color }) => (
  <svg viewBox="0 0 96 64" fill="none" aria-hidden>
    <rect x="18" y="6" width="60" height="40" rx="4" fill={color} opacity="0.18" />
    <rect x="22" y="10" width="52" height="32" rx="2" fill="#0f172a" opacity="0.55" />
    <rect x="42" y="46" width="12" height="6" fill={color} opacity="0.7" />
    <rect x="28" y="52" width="40" height="4" rx="2" fill={color} opacity="0.85" />
  </svg>
)

const ServerSvg = ({ color }) => (
  <svg viewBox="0 0 96 64" fill="none" aria-hidden>
    <rect x="16" y="8" width="64" height="14" rx="3" fill={color} opacity="0.85" />
    <rect x="16" y="25" width="64" height="14" rx="3" fill={color} opacity="0.65" />
    <rect x="16" y="42" width="64" height="14" rx="3" fill={color} opacity="0.45" />
    <circle cx="26" cy="15" r="2" fill="#fff" />
    <circle cx="26" cy="32" r="2" fill="#fff" />
    <circle cx="26" cy="49" r="2" fill="#fff" />
  </svg>
)

const ThinkPadSvg = ({ color }) => (
  <svg viewBox="0 0 96 64" fill="none" aria-hidden>
    <rect x="14" y="8" width="68" height="42" rx="4" fill={color} opacity="0.12" />
    <rect x="18" y="12" width="60" height="34" rx="2" fill={color} opacity="0.2" />
    <rect x="22" y="16" width="52" height="26" rx="1.5" fill="#0f172a" opacity="0.6" />
    <circle cx="48" cy="44" r="2.2" fill={color} />
    <path
      d="M8 52h80c1.5 0 2.5 1.2 2 2.5-.4 1-1.4 1.5-2.5 1.5H8.5C7.4 56 6.4 55.5 6 54.5 5.5 53.2 6.5 52 8 52Z"
      fill={color}
      opacity="0.9"
    />
  </svg>
)

const SurfaceSvg = ({ color }) => (
  <svg viewBox="0 0 96 64" fill="none" aria-hidden>
    <rect x="12" y="10" width="72" height="40" rx="5" fill={color} opacity="0.16" />
    <rect x="16" y="14" width="64" height="32" rx="3" fill="#0f172a" opacity="0.5" />
    <path d="M28 54h40l4 4H24l4-4Z" fill={color} opacity="0.85" />
  </svg>
)

const MacbookSvg = ({ color }) => (
  <svg viewBox="0 0 96 64" fill="none" aria-hidden>
    <rect x="16" y="8" width="64" height="40" rx="5" fill={color} opacity="0.16" />
    <rect x="20" y="12" width="56" height="32" rx="3" fill="#0f172a" opacity="0.5" />
    <path
      d="M10 50h76c1.2 0 2 .8 2 1.8S87.2 53.5 86 53.5H10c-1.2 0-2-.7-2-1.7S8.8 50 10 50Z"
      fill={color}
      opacity="0.85"
    />
    <rect x="44" y="9.5" width="8" height="1.5" rx="0.75" fill={color} opacity="0.7" />
  </svg>
)

const VirtualSvg = ({ color }) => (
  <svg viewBox="0 0 96 64" fill="none" aria-hidden>
    <rect x="22" y="10" width="52" height="34" rx="4" stroke={color} strokeWidth="2" fill="none" />
    <rect x="28" y="16" width="40" height="22" rx="2" fill={color} opacity="0.2" />
    <path d="M36 52h24M48 44v8" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
)

const pickSvg = (family) => {
  if (family === "server") return ServerSvg
  if (family === "desktop" || family === "mac-desktop") return DesktopSvg
  if (family === "virtual") return VirtualSvg
  if (family?.startsWith("lenovo-thinkpad")) return ThinkPadSvg
  if (family === "surface") return SurfaceSvg
  if (family?.startsWith("macbook") || family === "macbook") return MacbookSvg
  return LaptopSvg
}

/**
 * @param {"sm"|"md"|"lg"} size
 */
const DeviceModelImage = ({
  device,
  manufacturer,
  model,
  size = "md",
  showLabel = false,
  className = "",
}) => {
  const resolved = resolveDeviceModelImage(
    device || { sysInfo: { Manufacturer: manufacturer, Model: model } }
  )
  const Svg = pickSvg(resolved.family)
  return (
    <div
      className={`device-model-image device-model-image--${size} ${className}`.trim()}
      title={`${resolved.label}${resolved.model ? ` · ${resolved.model}` : ""}`}
      style={{ "--dm-tone": resolved.color }}
    >
      <div className="device-model-image__art">
        <Svg color={resolved.color} />
      </div>
      {showLabel ? (
        <div className="device-model-image__meta">
          <strong>{resolved.label}</strong>
          <span>{resolved.displayModel}</span>
        </div>
      ) : null}
    </div>
  )
}

export default DeviceModelImage
